import type { TableSemanticSchema } from './types';

export const RiskSchema: TableSemanticSchema = {
  id: 'risk',
  name: 'Risk Matrix',
  description:
    '5×5 likelihood-by-impact matrix with computed risk level and mitigation plan. Compatible with the GRC catalog — a risk_item can be promoted to a GRC risk node.',
  cells: [],
  itemFields: [
    { key: 'likelihood', label: 'Likelihood', kind: 'number', required: true, description: '1 (rare) to 5 (near-certain)' },
    { key: 'impact', label: 'Impact', kind: 'number', required: true, description: '1 (negligible) to 5 (catastrophic)' },
    { key: 'category', label: 'Category', kind: 'enum',
      options: [
        { value: 'operational', label: 'Operational' },
        { value: 'strategic', label: 'Strategic' },
        { value: 'financial', label: 'Financial' },
        { value: 'compliance', label: 'Compliance' },
        { value: 'technology', label: 'Technology' },
        { value: 'reputational', label: 'Reputational' },
      ] },
    { key: 'mitigation', label: 'Mitigation Plan', kind: 'string' },
    { key: 'owner', label: 'Owner', kind: 'string' },
    { key: 'status', label: 'Status', kind: 'enum',
      options: [
        { value: 'open', label: 'Open' },
        { value: 'mitigating', label: 'Mitigating' },
        { value: 'accepted', label: 'Accepted' },
        { value: 'closed', label: 'Closed' },
      ] },
  ],
  computedFields: [
    { key: 'riskScore', label: 'Risk Score',
      expression: { op: 'multiply', operands: ['likelihood', 'impact'] } },
    { key: 'riskLevel', label: 'Risk Level',
      expression: {
        op: 'classify',
        field: 'riskScore',
        bands: [
          { max: 4, label: 'low' },
          { max: 9, label: 'medium' },
          { max: 16, label: 'high' },
          { max: 25, label: 'critical' },
        ],
      } },
  ],
  renderingHints: {
    layout: 'grid',
    cellColors: {
      low: '#bbf7d0',
      medium: '#fde68a',
      high: '#fecaca',
      critical: '#fca5a5',
    },
  },
};
